module.exports = __webpack_public_path__ + "static/media/12.fa6d2eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/12.jpg
// module id = 545
// module chunks = 0